import { useState, useMemo, createContext, useContext } from 'react'
import {
  LightspeedBusiness,
  LightspeedStore
} from '../Manage/ManageLightspeed/types'
import { ShipdayIntegration } from '../Manage/ManageShipday/types'

type IntegrationState = {
  lightspeedBusinesses: LightspeedBusiness[]
  setLightspeedBusinesses: (businesses: LightspeedBusiness[]) => void
  lightspeedAuthExpired: boolean
  setLightspeedAuthExpired: (expired: boolean) => void
  lightspeedStores: LightspeedStore[]
  setLightspeedStores: (stores: LightspeedStore[]) => void
  lightspeedStoresLoading: boolean
  setLightspeedStoresLoading: (loading: boolean) => void
  refetchLightspeedStores: () => Promise<unknown>
  setRefetchLightspeedStores: (refetch: () => Promise<unknown>) => void
  shipdayIntegrations: ShipdayIntegration[]
  setShipdayIntegrations: (integrations: ShipdayIntegration[]) => void
  refetchShipdayIntegrations: () => Promise<unknown>
  setRefetchShipdayIntegrations: (refetch: () => Promise<unknown>) => void
}

export const SetupIntegration = (): IntegrationState => {
  const [lightspeedBusinesses, setLightspeedBusinesses] = useState<
    LightspeedBusiness[]
  >([])
  const [lightspeedAuthExpired, setLightspeedAuthExpired] = useState(false)

  const [lightspeedStores, setLightspeedStores] = useState<LightspeedStore[]>(
    []
  )
  const [lightspeedStoresLoading, setLightspeedStoresLoading] = useState(false)
  const [refetchLightspeedStores, setRefetchLightspeedStores] = useState<
    () => Promise<unknown>
  >(() => () => Promise.resolve())

  const [shipdayIntegrations, setShipdayIntegrations] = useState<
    ShipdayIntegration[]
  >([])
  const [refetchShipdayIntegrations, setRefetchShipdayIntegrations] = useState<
    () => Promise<unknown>
  >(() => () => Promise.resolve())

  return useMemo(
    () => ({
      lightspeedBusinesses,
      setLightspeedBusinesses,
      lightspeedAuthExpired,
      setLightspeedAuthExpired,
      lightspeedStores,
      setLightspeedStores,
      lightspeedStoresLoading,
      setLightspeedStoresLoading,
      refetchLightspeedStores,
      setRefetchLightspeedStores,
      shipdayIntegrations,
      setShipdayIntegrations,
      refetchShipdayIntegrations,
      setRefetchShipdayIntegrations
    }),
    [
      lightspeedBusinesses,
      lightspeedAuthExpired,
      lightspeedStores,
      lightspeedStoresLoading,
      refetchLightspeedStores,
      shipdayIntegrations,
      refetchShipdayIntegrations
    ]
  )
}

const initialState: IntegrationState = {
  lightspeedBusinesses: [],
  setLightspeedBusinesses: () => null,
  lightspeedAuthExpired: false,
  setLightspeedAuthExpired: () => null,
  lightspeedStores: [],
  setLightspeedStores: () => null,
  lightspeedStoresLoading: false,
  setLightspeedStoresLoading: () => null,
  refetchLightspeedStores: () => Promise.resolve(),
  setRefetchLightspeedStores: () => null,
  shipdayIntegrations: [],
  setShipdayIntegrations: () => null,
  refetchShipdayIntegrations: () => Promise.resolve(),
  setRefetchShipdayIntegrations: () => null
}

export const IntegrationContext = createContext<IntegrationState>(initialState)

export const useIntegration = () => {
  return useContext(IntegrationContext)
}
